"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BidDataFilterService = exports.ServerSideOptions = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
const _ = require("lodash");
//INTERNAL LIBRARY BITS
const boolean_key_pipe_1 = require("./boolean-key.pipe");
const bidder_service_1 = require("./bidder.service");
const clients_service_1 = require("./clients.service");
const data_metric_service_1 = require("./data-metric.service");
const permission_service_1 = require("./permission.service");
const user_service_1 = require("./user.service");
const data_level_service_1 = require("./data-level.service");
const data_source_service_1 = require("./data-source.service");
//VARIABLE MODELS
const date_range_1 = require("./date-range");
const filters_menu_data_1 = require("./filters-menu-data");
const organizations_service_1 = require("./organizations.service");
class ServerSideOptions {
}
exports.ServerSideOptions = ServerSideOptions;
let BidDataFilterService = class BidDataFilterService {
    constructor(_http, _booleanKey, _bidder, _dataLevel, _clients, _dataMetric, _user, _permission, _dataSource, _organizations) {
        this._http = _http;
        this._booleanKey = _booleanKey;
        this._bidder = _bidder;
        this._dataLevel = _dataLevel;
        this._clients = _clients;
        this._dataMetric = _dataMetric;
        this._user = _user;
        this._permission = _permission;
        this._dataSource = _dataSource;
        this._organizations = _organizations;
        this.filtersUrl = '/filter';
        this.DEFAULT_FILTER_DATA_SOURCE = 'biddr';
        this.MAX_SELECTABLE_FILTERS = 300;
        this.FILTERS_KEYS = {
            DOMAIN: 'domain',
            SIZE: 'size',
            ORGANIZATION: 'organization_id',
            BIDDER: 'bidder',
            DEAL: 'deal_id',
            ADUNITCODE: 'adunitcode',
            PUBLISHER: 'client_id',
            DEAL_TYPE: 'deal_type'
        };
        this.HELM_DATA_TYPE_PERMISSIONS = [
            'dashboard-metric--adjusted_renders',
            'dashboard-metric--adjusted_dfp_revenue',
            'dashboard-metric--adjusted_ecpm'
        ];
        this.dateRanges = [{ displayName: 'Today', selected: false }, { displayName: 'Yesterday', selected: false }, { displayName: 'Last 7 Days', selected: false }, { displayName: 'Last 14 Days', selected: false }, { displayName: 'Last 30 Days', selected: false }, { displayName: 'This Month', selected: false }, { displayName: 'Last Month', selected: false }, { displayName: 'Last 24 Hours', selected: false }];
        this.customDateRange = false;
        this.dateRangeName = 'Last 7 Days';
        this.dateRange = new date_range_1.DateRange;
        this.intervals = [];
        this.domains = [];
        this.adUnits = [];
        this.sizes = [];
        this.publishers = [];
        this.demandPartners = [];
        this.searchPublishers = '';
        this.searchDomains = '';
        this.searchAdUnits = '';
        this.searchSizes = '';
        this.searchDemandPartners = '';
        this.searchDeals = '';
        this.cumulative = true;
        this.clientIds = [];
        this.filterBidders = false;
        this.showAllDomains = false;
        this.groupByFilters = {
            [this.FILTERS_KEYS.PUBLISHER]: false,
            [this.FILTERS_KEYS.ORGANIZATION]: false,
            [this.FILTERS_KEYS.DOMAIN]: false,
            [this.FILTERS_KEYS.ADUNITCODE]: false,
            [this.FILTERS_KEYS.SIZE]: false,
            [this.FILTERS_KEYS.BIDDER]: true, // Bidder it's default for all sources
            [this.FILTERS_KEYS.DEAL]: false,
            [this.FILTERS_KEYS.DEAL_TYPE]: false
        };
        this.helm = false;
        this.filtersData = {};
        this.serverSide = {
            publishers: [],
            demandPartners: [],
            adUnits: [],
            deals: [],
            domains: []
        };
    }
    setQParams(customParams) {
        if (customParams) {
            const params = this.parseQuery(customParams);
            if (!params.helm) {
                this.clearHelmChecked();
            }
            return Promise.resolve((this._http.qParams = params));
        }
        this.qParams = '';
        return Promise.resolve(this.qParams = this.getBidDataFiltersQS()).then(err => {
            this.qParams += '&dataSource=' + this._dataSource.getCurrentSource().slug;
            if (this.sortList) {
                this.qParams += this.sortList;
            }
            if (this._dataMetric.getHidden().length > 0) {
                this.qParams += this._dataMetric.getVisibleFilterColumns();
            }
            if (this.isHelmChecked()) {
                this.qParams += '&helm=' + this.isHelmChecked();
            }
            return Promise.resolve(this.getGroupBy()).then(r => {
                if (this.groupParams) {
                    this.qParams += this.groupParams;
                }
                this._http.qParams = this.parseQuery(this.qParams);
                return true;
            });
            //	if((JSON.stringify(this.qParams).length + 53) > 2083) {
            //		return this._talk.broadcast("Query filters exceed the maximum possible length for url.  Please simplify your query if you intend to copy and share the url for this query.");
            //	}
        });
    }
    resetQParams() {
        this.qParams = '';
    }
    getQParams() {
        return this.qParams;
    }
    getParsedQParams() {
        return this.parsedQParams;
    }
    parseQuery(qstr) {
        var query = {};
        var a = (qstr[0] === '?' ? qstr.substr(1) : qstr).split('&');
        for (var i = 0; i < a.length; i++) {
            var b = a[i].split('=');
            var keys = Object.keys(query);
            var key = keys.filter(function (key) { return key == decodeURIComponent(b[0]); })[0];
            var c;
            if (typeof key != 'undefined') {
                c = JSON.parse(JSON.stringify(query[key]));
                query[key] = [];
                if (c) {
                    if (!Array.isArray(c)) {
                        c = [c];
                    }
                    for (var j = 0; j < c.length; j++) {
                        if (query[key].indexOf(c[j]) < 0) {
                            query[key].push(c[j]);
                        }
                    }
                }
                query[key].push(decodeURIComponent(b[1] || ''));
            }
            else {
                query[decodeURIComponent(b[0])] = decodeURIComponent(b[1] || '');
            }
        }
        this.parsedQParams = query;
        return query;
    }
    getShowAllDomains() {
        return this.showAllDomains;
    }
    getSort() {
        return this.sortList;
    }
    setSort(sortList) {
        this.sortList = "&sort=" + sortList;
    }
    setDataSource(ds) {
        this._dataSource.setCurrentSource(ds);
        this.initGroupBy();
    }
    getDataSource() {
        return this._dataSource.getCurrentSource();
    }
    getHelmDashboardDataSource() {
        return this._dataSource.getSource('rtbx-helm-dashboard');
    }
    setShowAllDomains(sad) {
        this.showAllDomains = sad;
    }
    getSearchPublishers() {
        return this.searchPublishers;
    }
    setSearchPublishers(s) {
        return this.searchDomains = s;
    }
    getSearchDomains() {
        return this.searchDomains;
    }
    setSearchDomains(s) {
        return this.searchDomains = s;
    }
    getSearchAdUnits() {
        return this.searchAdUnits;
    }
    setSearchAdUnits(s) {
        return this.searchAdUnits = s;
    }
    getSearchSizes() {
        return this.searchSizes;
    }
    setSearchSizes(s) {
        return this.searchSizes = s;
    }
    getSearchDemandPartners() {
        return this.searchDemandPartners;
    }
    setSearchDemandPartners(s) {
        return this.searchDemandPartners = s;
    }
    getSearchDeals() {
        return this.searchDeals;
    }
    setSearchDeals(s) {
        return this.searchDeals = s;
    }
    getFilterBidders() {
        return this.filterBidders;
    }
    getBidders() {
        return this.bidders;
    }
    getDateRanges() {
        return this.dateRanges;
    }
    getDateRangeName() {
        return this.dateRangeName;
    }
    setDateRangeByName(name, setInterval = true) {
        this.dateRangeName = name;
        if (setInterval) {
            this.setAvailableIntervals(this.dateRangeName);
            this.setSmallestAvailableInterval();
        }
        for (let range in this.dateRanges) {
            this.dateRanges[range].selected = false;
            if (this.dateRanges[range].displayName == this.dateRangeName) {
                this.dateRanges[range].selected = true;
                this.setDateRange(this.calculateDateRangeByName(this.convertKeyToLowerCase(this.dateRangeName)));
            }
        }
        return this.dateRange;
    }
    buildDateRangesTimes() {
        let dataSourceTimeRange = this.getDataSourceTimeRange();
        return {
            'today': [moment().startOf('day'), moment().startOf('h')],
            'last_24_hours': [moment().subtract(1, 'days').startOf('d').startOf('h'), moment().startOf('h')],
            'yesterday': [moment().subtract(1, 'days').startOf('d'), moment().subtract(1, 'days').endOf('d').startOf('h')],
            'last_7_days': [moment().subtract(7, 'days').startOf('d'), moment().subtract(1, 'days').endOf('d').startOf('h')],
            'last_14_days': [moment().subtract(14, 'days').startOf('d'), moment().subtract(1, 'days').endOf('d').startOf('h')],
            'last_30_days': [moment().subtract(30, 'days').startOf('d'), moment().subtract(1, 'days').endOf('d').startOf('h')],
            'this_month': [moment().startOf('month'), moment().startOf('h')],
            'last_month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month').startOf('h')],
            'lifetime': [dataSourceTimeRange.start, dataSourceTimeRange.end]
        };
    }
    setDateRange(range) {
        this.dateRange = {
            start: moment(range.start).format("YYYY-MM-DD HH:mm:ss"),
            end: moment(range.end).format("YYYY-MM-DD HH:mm:ss"),
            name: range.name
        };
        return this.dateRange;
    }
    /**
     * Convert given key from 'some${delimiter}key' to Some Key, or 'lowekey' => 'Lowkey'
     */
    strToUpperCaseBy(str = '', delimiter = '_', joinBy = ' ') {
        return str.split(delimiter)
            .map(k => `${k[0].toUpperCase()}${k.slice(1)}`)
            .join(joinBy);
    }
    calculateDateRangeByName(range) {
        const dateRangesTimes = this.buildDateRangesTimes();
        const rangeKey = this.convertKeyToLowerCase(range);
        // retrieve the values from the appropiate dateRangeTime, or use last_7_days range as default
        const [start, end] = dateRangesTimes[rangeKey] || dateRangesTimes['last_7_days'];
        const dateRange = {
            start,
            end,
            name: range
        };
        return dateRange;
    }
    convertKeysToUpperCase(object = {}) {
        const updated = {};
        for (let key in object) {
            updated[this.strToUpperCaseBy(key, '_', ' ')] = object[key];
        }
        return updated;
    }
    convertKeyToLowerCase(key = '') {
        return key.toLowerCase().replace(/ /g, '_');
    }
    getDateRange() {
        return this.dateRange;
    }
    getInterval() {
        return this.intervalName || '';
    }
    formattedStartTime() {
        return moment(this._dataSource.getCurrentSource().startTime).utcOffset(this._user.getTimezone().time).format("YYYY-MM-DD HH:mm:ss");
    }
    formattedEndTime() {
        return moment(this._dataSource.getCurrentSource().endTime).utcOffset(this._user.getTimezone().time).format("YYYY-MM-DD HH:mm:ss");
    }
    defaultMinDateRange() {
        return moment(this.formattedStartTime());
    }
    defaultMaxDateRange() {
        return moment().utcOffset(this._user.getTimezone().time).startOf('hour');
    }
    getDataSourceTimeRange() {
        const currentSource = this._dataSource.getCurrentSource();
        return {
            start: currentSource.startTime ? moment(currentSource.startTime) : null,
            end: currentSource.endTime ? moment(currentSource.endTime).endOf('d').startOf('h') : moment().endOf('d').startOf('h')
        };
    }
    getDateRangeOptions() {
        let dateRangeOptions = {
            minDate: this.defaultMinDateRange(),
            maxDate: this.defaultMaxDateRange(),
            ranges: {},
            parentEl: 'section:first-child',
            timePicker: true,
            timePicker24Hour: true,
            timePickerIncrement: 60
        };
        let dataSourceTimeRange = this.getDataSourceTimeRange();
        const dateRanges = this.convertKeysToUpperCase(this.buildDateRangesTimes());
        if (!dataSourceTimeRange.start) {
            dateRangeOptions.ranges = dateRanges;
            return dateRangeOptions;
        }
        for (let key in dateRanges) {
            let dateRange = dateRanges[key];
            let startEqualToOrBeforeOption = (dataSourceTimeRange.start.diff(dateRange[0]) === 0 || dataSourceTimeRange.start.isBefore(dateRange[0]));
            let endEqualToOrAfterOption = (dataSourceTimeRange.end.diff(dateRange[1]) === 0 || dataSourceTimeRange.end.isAfter(dateRange[1]));
            let lifetimeOption = key === 'Lifetime';
            let isTimeRangeVisible = (startEqualToOrBeforeOption && endEqualToOrAfterOption) || lifetimeOption;
            if (isTimeRangeVisible) {
                dateRangeOptions.ranges[key] = dateRange;
            }
        }
        return dateRangeOptions;
    }
    setAvailableIntervals(range) {
        let rangeKey = range.toLowerCase();
        const defaultRangeSetting = (dailyEnabled = false) => [
            { displayName: 'Hourly', enabled: true, selected: false },
            { displayName: 'Daily', enabled: dailyEnabled, selected: false },
            { displayName: 'Monthly', enabled: false, selected: false }
        ];
        const intervalsRangeSetting = {
            'today': defaultRangeSetting,
            'last 24 hours': defaultRangeSetting,
            'yesterday': defaultRangeSetting,
            'last 7 days': () => defaultRangeSetting(true),
            'last 14 days': () => defaultRangeSetting(true),
            'last 30 days': () => [
                { displayName: 'Hourly', enabled: false, selected: false },
                { displayName: 'Daily', enabled: true, selected: false },
                { displayName: 'Monthly', enabled: true, selected: false }
            ],
            'this month': () => {
                const monthDateRange = this.calculateDateRangeByName(rangeKey);
                return [
                    { displayName: 'Hourly', enabled: (moment(monthDateRange.end).diff(moment(monthDateRange.start), 'days', true) < 7) },
                    { displayName: 'Daily', enabled: true, selected: false },
                    { displayName: 'Monthly', enabled: false, selected: false }
                ];
            },
            'last month': () => [
                { displayName: 'Hourly', enabled: false, selected: false },
                { displayName: 'Daily', enabled: true, selected: false },
                { displayName: 'Monthly', enabled: true, selected: false }
            ],
            'lifetime': () => [
                { displayName: 'Hourly', enabled: false, selected: false },
                { displayName: 'Daily', enabled: false, selected: false },
                { displayName: 'Monthly', enabled: true, selected: false }
            ],
            'custom': () => {
                this.customDateRange = !this.customDateRange;
                for (let range in this.dateRanges) {
                    this.dateRanges[range].selected = false;
                }
                return [
                    { displayName: 'Hourly', enabled: (moment(this.dateRange.end).diff(moment(this.dateRange.start), 'days', true) < 14) },
                    { displayName: 'Daily', enabled: (moment(this.dateRange.end).diff(moment(this.dateRange.start), 'months', true) < 3), selected: false },
                    { displayName: 'Monthly', enabled: (moment(this.dateRange.end).diff(moment(this.dateRange.start), 'days', true) > 30), selected: false }
                ];
            }
        };
        //Check 'custom range' key, to maintain compatibility
        if (rangeKey == 'custom range') {
            rangeKey = 'custom';
        }
        return (intervalsRangeSetting[rangeKey])
            ? (this.intervals = intervalsRangeSetting[rangeKey]())
            : (console.warn(`BAD DATE RANGE SENT TO INTERVALS: ${rangeKey} - using defaultRangeSetting`), (this.intervals = defaultRangeSetting()));
    }
    setInterval(menu) {
        this.intervalName = menu;
        for (let i in this.intervals) {
            this.intervals[i].selected = false;
            if (this.intervals[i].displayName.toLowerCase() == this.intervalName.toLowerCase()) {
                this.intervals[i].selected = true;
            }
        }
    }
    setSmallestAvailableInterval() {
        const allowedMultipleEnabledIntervals = ['Last 7 Days', 'Last 14 Days', 'Custom Range'];
        const allowedIntervalsNames = this.intervals.filter(i => i.enabled).map(i => i.displayName);
        const canSetAsSmallest = (interval) => (typeof this.intervalName !== 'undefined'
            && allowedMultipleEnabledIntervals.includes(this.dateRangeName)
            && allowedIntervalsNames.includes(this.intervalName))
            ? this.intervalName === interval.displayName
            : true;
        for (let i in this.intervals) {
            if (this.intervals[i].enabled && canSetAsSmallest(this.intervals[i])) {
                this.intervals[i].selected = true;
                this.intervalName = this.intervals[i].displayName;
                break;
            }
        }
    }
    getIntervals() {
        return this.intervals;
    }
    getCumulative() {
        return this.cumulative;
    }
    setMenuOption(filterSlug, filterSource, menuOption, toggleTo) {
        const filterOptions = this.getFilterLocalData(filterSlug, filterSource);
        return this.updateFilterOption(filterSlug, filterSource, filterOptions.data, menuOption, toggleTo);
    }
    updateFilterSelectionCount(filterSlug, filterSource, optionId, optionSelected) {
        if (optionSelected !== undefined) {
            if (optionSelected && !this.reachedMaxFilterSelection(filterSlug, filterSource)) // if option was selected
                this.addSelectedFilterOption(filterSlug, filterSource, optionId);
            else if (!optionSelected) // if it was unselected
                this.removeSelectedFilterOption(filterSlug, filterSource, optionId);
        }
    }
    addSelectedFilterOption(filterSlug, filterSource, optionId) {
        if (this.hasFilterData(filterSlug, filterSource)) {
            return this.getFilterLocalData(filterSlug, filterSource).selectedFilters.add(optionId);
        }
    }
    removeSelectedFilterOption(filterSlug, filterSource, optionId) {
        return this.getFilterLocalData(filterSlug, filterSource).selectedFilters.delete(optionId);
    }
    hasSelectedFilterOption(filterSlug, filterSource, optionId) {
        return this.getFilterLocalData(filterSlug, filterSource).selectedFilters.has(optionId);
    }
    reachedMaxFilterSelection(filterSlug, filterSource) {
        // only allow to select up to the max selectable;
        return (this.getTotalSelectedFilterOptions(filterSlug, filterSource) >= this.MAX_SELECTABLE_FILTERS);
    }
    getTotalSelectedFilterOptions(filterSlug, filterSource) {
        return this.getFilterLocalData(filterSlug, filterSource).selectedFilters.size;
    }
    getBiddersAdunitsMapping(adUnitsToMap = []) {
        return this._bidder.getAdUnitGroups().map(bidder => {
            let empty = 0;
            for (let adU in bidder.adUnits) {
                for (let bind in adUnitsToMap) {
                    if (bidder.adUnits[adU] === adUnitsToMap[bind].value) {
                        bidder.adUnits[adU] = adUnitsToMap[bind];
                        break;
                    }
                    if (adUnitsToMap.indexOf(adUnitsToMap[bind]) === (adUnitsToMap.length - 1)) {
                        bidder.adUnits[adU] = { displayName: "[NO DATA] " + bidder.adUnits[adU], data: false };
                    }
                }
                if (bidder.adUnits[adU].data == false) {
                    empty++;
                }
            }
            if (empty == bidder.adUnits.length) {
                bidder.adUnits = [{ displayName: "No data was found for this bidder" }];
            }
            return { displayName: bidder.displayName, selected: false, count: 0, enabled: true, collapsed: false, adUnits: bidder.adUnits };
        });
    }
    updateFilterOption(filterSlug, filterSource, filterData, menuOption, toggleTo) {
        if (filterData.size > 0) {
            for (let option of filterData.values()) {
                const optionId = this.buildFilterDataId(option);
                if (optionId === this.buildFilterDataId(menuOption)) {
                    const newSelectedState = (toggleTo !== undefined) ? toggleTo : !option.selected;
                    // if processing the one before last, we can update
                    if (this.getTotalSelectedFilterOptions(filterSlug, filterSource) === this.MAX_SELECTABLE_FILTERS - 1) {
                        option.selected = newSelectedState;
                    }
                    this.updateFilterSelectionCount(filterSlug, filterSource, optionId, newSelectedState);
                    // Stop processing if we are enabling selection and reached the max selectable;
                    if (newSelectedState && this.reachedMaxFilterSelection(filterSlug, filterSource))
                        return;
                    option.selected = newSelectedState;
                    return option;
                }
            }
        }
    }
    setCumulative(cumulative) {
        this.cumulative = cumulative;
    }
    initGroupBy() {
        //reset current grouping to initial state
        this.clearGrouping();
        // initialize any of the grouping keys from the current data source
        this._dataMetric.getGroupingMetrics()
            .forEach(metric => {
            this.groupByFilters[metric.slug] = false;
        });
    }
    setGroupBy(filter) {
        if (typeof this.groupByFilters[filter] != 'undefined') {
            this.groupByFilters[filter] = !this.groupByFilters[filter]; //flips a boolean
        }
        else {
            return console.error('Improper filter to group by', filter);
        }
    }
    getGroupBy() {
        return this.groupByFilters;
    }
    canGroupBy(groupSlug, perms = this._permission.get()) {
        return perms['dashboard-filters--all'] || perms[`dashboard-filter--${groupSlug}`];
    }
    // [#652] Remove when transitioned to JSON Request
    getEnabledGroupsParamsQS(paramKey = '') {
        let group = '';
        for (let groupKey in this.groupByFilters) {
            if (this.groupByFilters[groupKey] && this._dataMetric.isValidSourceMetric(groupKey) && this.canGroupBy(groupKey)) {
                group += `&${paramKey}=${groupKey}`;
            }
        }
        return group;
    }
    getEnabledGroupsParamsJSON() {
        let group = [];
        for (let groupKey in this.groupByFilters) {
            if (this.groupByFilters[groupKey] && this._dataMetric.isValidSourceMetric(groupKey) && this.canGroupBy(groupKey)) {
                group.push(groupKey);
            }
        }
        return group;
    }
    // [#652] Remove when transitioned to JSON Request
    getGroupByColumnsQS() {
        return this.getEnabledGroupsParamsQS('col');
    }
    getGroupByColumnsJSON() {
        return this.getEnabledGroupsParamsJSON();
    }
    // [#652] Remove when transitioned to JSON Request
    getGroupByGroupsQS() {
        return this.getEnabledGroupsParamsQS('group');
    }
    getGroupByGroupsJSON() {
        const params = this.getEnabledGroupsParamsQS('group');
        // TODO: remove this side effect
        this.groupParams = params;
        return this.getEnabledGroupsParamsJSON();
    }
    clearGrouping() {
        let keys = Object.keys(this.groupByFilters);
        for (let key in keys) {
            this.groupByFilters[keys[key]] = false;
        }
    }
    setDefaultGrouping() {
        if (this._permission.get()['dashboard-group-by-bidder'])
            this.groupByFilters['bidder'] = true;
        this.clearGrouping();
    }
    deselectMenuOptions(menuOptionArray) {
        for (let item in menuOptionArray) {
            menuOptionArray[item].selected = false;
        }
    }
    setProductFilters() {
        const perms = this._permission.get();
        let isConnect = (perms && perms['system-branding--biddr_connect']);
        if (isConnect) {
            this.setInterval('Daily');
            this.setCumulative(false);
        }
    }
    resetAllFilters() {
        this.setDateRangeByName('Last 7 Days');
        this.intervalName = "Cumulative";
        this._http.qParams = {};
        this.qParams = '';
        this.parsedQParams = {};
        this.clearGrouping();
        this.setCumulative(true);
        this.groupByFilters.bidder = true;
        this.resetAllSourcesFiltersData();
        this.setProductFilters();
        return true;
    }
    resetAllSourcesFiltersData() {
        const sources = this._dataSource.get();
        if (sources && sources.length) {
            sources.forEach(source => {
                this.resetAllFiltersData(source.slug);
            });
        }
    }
    setFallbackTime() {
        let dataSourceTimeRange = this.getDataSourceTimeRange();
        let difference = moment().diff(dataSourceTimeRange.start, 'day');
        if (difference < 7) {
            this.setDateRangeByName('Today');
        }
        else {
            this.setDateRangeByName('Last 7 Days');
        }
    }
    pullRTBPublishers() {
        return __awaiter(this, arguments, void 0, function* (requestParams = {}) {
            const publisherEndpoint = this.getFilterValueKey(this.FILTERS_KEYS.PUBLISHER);
            const sourceSlug = this._dataSource.RTBX;
            const queryParams = Object.assign({
                limit: 300 //only get first 300 all other should be lazy loaded
            }, requestParams);
            const response = yield this.pullNewFilterData(publisherEndpoint, sourceSlug, queryParams);
            return response.data;
        });
    }
    pull() {
        return __awaiter(this, void 0, void 0, function* () {
            // Setting the fallback 
            this.setFallbackTime();
            if (typeof this.getDataSource().slug === 'undefined') {
                const dataSources = this._dataSource.get();
                if (dataSources && dataSources.length > 0) {
                    this.setDataSource(dataSources[0]);
                }
                else {
                    console.error('no permissioned Data Sources for user');
                    return Promise.resolve(false);
                }
            }
            this.setDateRangeByName(this.dateRangeName);
            // Load and set any query params values detected from the the current URL
            if (this._http.qParams) {
                yield this.setQueryParamsFilterValues(this.parseQueryParamKeyValue(this._http.qParams), this._http.qParams);
            }
        });
    }
    setQueryParamsFilterValues(filtersValues, paramObj) {
        return __awaiter(this, void 0, void 0, function* () {
            // hide all filters data metrics
            if (paramObj['col'] && paramObj['col'].length > 0) {
                this._dataMetric.setAllVisibility(false);
            }
            const qParamDataSource = this._dataSource.getSource(paramObj.dataSource || paramObj.data_source);
            const queryParamsHelpers = this.getQueryParamsSetterHelpers();
            const filtersKeys = Object.keys(filtersValues);
            for (let filter of filtersKeys) {
                // Call the  helper to set the query params values
                if (queryParamsHelpers[filter]) {
                    // call any required method before calling the setter for each value
                    if (queryParamsHelpers[filter].callBeforeSetter) {
                        queryParamsHelpers[filter].callBeforeSetter.call(this);
                    }
                    //Use the helper setter object or default for the main expected fn
                    const helperSetter = queryParamsHelpers[filter].setter || queryParamsHelpers[filter];
                    // trigger load of the query params
                    // any async requests should be handled gracefully by its setter helper
                    if (queryParamsHelpers[filter].passAllValues)
                        yield helperSetter.call(this, filtersValues[filter], filter, qParamDataSource.slug);
                    else
                        yield this.callEachFilterValueWith(helperSetter, filtersValues, filter, qParamDataSource.slug);
                }
                else {
                    console.warn(`No setter helper found for filter(${filter})`);
                }
            }
        });
    }
    callEachFilterValueWith(fn, filterValues, filterSlug, dataSource) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let value of filterValues[filterSlug]) {
                yield fn.call(this, value, filterSlug, dataSource);
            }
        });
    }
    getQueryParamsSetterHelpers() {
        // create a set of the filters query params keys
        // to each required setter helper function
        const paramsHelpers = {
            dateRange: this.setDateRangeNamesParams,
            start: this.setDateRangeStartEndParams,
            end: this.setDateRangeStartEndParams,
            interval: this.setIntervalParams,
            cumulativeView: this.setCumulativeViewParams,
            group: { callBeforeSetter: this.clearGrouping, setter: this.setGroupsParams },
            sort: this.setSortListParams,
            col: this.setColumnParams,
            tz: this.setTimezoneParams,
            data_source: this.setDataSourceParams,
            dataSource: this.setDataSourceParams, // dataSource pending to be consolidated to data_source when other parts are migrated 
            helm: this.setHelm,
            // Grouping FILTERS 
            [this.FILTERS_KEYS.ADUNITCODE]: { setter: this.setDataFilterParams, passAllValues: true },
            [this.FILTERS_KEYS.SIZE]: { setter: this.setDataFilterParams, passAllValues: true },
            [this.FILTERS_KEYS.BIDDER]: { setter: this.setDataFilterParams, passAllValues: true },
            [this.FILTERS_KEYS.PUBLISHER]: { setter: this.setDataFilterParams, passAllValues: true },
            [this.FILTERS_KEYS.DOMAIN]: { setter: this.setDataFilterParams, passAllValues: true },
            [this.FILTERS_KEYS.DEAL]: { setter: this.setDataFilterParams, passAllValues: true },
            [this.FILTERS_KEYS.ORGANIZATION]: { setter: this.setDataFilterParams, passAllValues: true },
            [this.FILTERS_KEYS.DEAL_TYPE]: { setter: this.setDataFilterParams, passAllValues: true },
            // Other Filters ...
        };
        return paramsHelpers;
    }
    /**
     * Query Params Setters Helpers
     */
    setDateRangeNamesParams(value) {
        if (value == "Custom Range" || value == "Custom") {
            this.dateRangeName = "Custom";
            this.dateRange.name = this.dateRangeName;
            this.setAvailableIntervals(this.dateRangeName);
        }
        for (let dR in this.dateRanges) {
            this.dateRanges[dR].selected = false;
            if (this.dateRanges[dR].displayName === this.strToUpperCaseBy(value)) {
                this.dateRangeName = this.strToUpperCaseBy(value);
                this.dateRanges[dR].selected = true;
                this.setDateRange(this.calculateDateRangeByName(this.dateRangeName));
                this.setAvailableIntervals(this.dateRangeName);
            }
        }
    }
    setDateRangeStartEndParams(dateStr, paramKey) {
        if (this.dateRangeName === 'Custom') {
            this.dateRange[paramKey] = dateStr;
        }
    }
    setIntervalParams(interval) {
        for (let i in this.intervals) {
            this.intervals[i].selected = false;
            if (this.trimSpaces(this.intervals[i].displayName.toLowerCase()) === interval.toLowerCase() && this.intervals[i].enabled) {
                this.intervals[i].selected = true;
                this.intervalName = this.intervals[i].displayName;
            }
        }
    }
    setCumulativeViewParams(cumulativeView) {
        if (cumulativeView === 'false') {
            this.cumulative = false;
        }
    }
    setGroupsParams(group) {
        if (typeof this.groupByFilters[group] !== 'undefined') {
            this.groupByFilters[group] = true;
        }
    }
    setSortListParams(sortList) {
        this.sortList = sortList;
    }
    setColumnParams(column) {
        this._dataMetric.setSingleVisibility(column, true);
    }
    setTimezoneParams(tz) {
        this.tz = tz;
    }
    setDataSourceParams(dataSourceSlug) {
        this._dataSource.setCurrentSource(this._dataSource.getSource(dataSourceSlug));
    }
    setHelm(helm) {
        this.helm = helm;
    }
    parseQueryParamKeyValue(paramObj) {
        const paramKeys = Object.keys(paramObj || {});
        // Create a set of the query params keys to their respective values {<filterKey>: value}
        return paramKeys.reduce((paramsFilters, paramKey) => {
            const filter = paramKey || '';
            if (!paramsFilters[filter])
                paramsFilters[filter] = {};
            let value = paramObj[paramKey] || '';
            if (value.indexOf(',') > -1) {
                value = value.split(',');
            }
            if (!Array.isArray(value))
                value = [value];
            paramsFilters[filter] = value;
            return paramsFilters;
        }, {});
    }
    // [#652] Remove when transitioned to JSON Request
    getBidDataFiltersQS() {
        let filters = '';
        const hourModifier = this._user.getTimezoneModifier();
        //START FILTERS VARIABLE WITH DATE RANGE
        filters += 'dateRange=' + this.dateRange.name
            + '&start=' + moment(this.dateRange.start).subtract(hourModifier, 'hours').format('YYYY-MM-DD HH:mm:ss')
            + '&end=' + moment(this.dateRange.end).subtract(hourModifier, 'hours').format('YYYY-MM-DD HH:mm:ss');
        //ADD INTERVAL IF NOT CUMULATIVE
        if (this.cumulative == false)
            filters += '&interval=' + this.intervalName.toLowerCase();
        filters += '&cumulativeView=' + this.cumulative;
        const currentDataSource = this._dataSource.getCurrentSource();
        // build bid data grouping filters selected values params
        filters += Object.keys(this.groupByFilters).reduce((str, filterKey) => {
            str += this.buildFilterSelectedValuesStr(filterKey, currentDataSource.slug);
            return str;
        }, '');
        return filters;
    }
    getBidDataFiltersJSON() {
        const hourModifier = this._user.getTimezoneModifier();
        //START FILTERS VARIABLE WITH DATE RANGE
        let filters = {
            dateRange: this.dateRange.name,
            start: moment(this.dateRange.start).subtract(hourModifier, 'hours').format('YYYY-MM-DD HH:mm:ss'),
            end: moment(this.dateRange.end).subtract(hourModifier, 'hours').format('YYYY-MM-DD HH:mm:ss'),
            cumulativeView: this.cumulative
        };
        //ADD INTERVAL IF NOT CUMULATIVE
        if (this.cumulative == false)
            filters.interval = this.intervalName.toLowerCase();
        const currentDataSource = this._dataSource.getCurrentSource();
        // build bid data grouping filters selected values params
        Object.keys(this.groupByFilters).forEach(filterKey => {
            let values = this.buildFilterSelectedValuesArr(filterKey, currentDataSource.slug);
            if (values.length) {
                filters[filterKey] = values;
            }
        });
        return filters;
    }
    canToggleHelm() {
        let perms = this._permission.get();
        return perms['dashboard-helm'] && this._dataSource.getCurrentSource().isServerSide();
    }
    isHelmChecked() {
        return this.helm;
    }
    toggleHelmChecked() {
        this.helm = !this.helm;
    }
    clearHelmChecked() {
        this.helm = false;
    }
    getClientTimezone() {
        return this._user.getTimezone().time || '+00:00';
    }
    getClientTimezoneModifier() {
        return this._user.getTimezoneModifier();
    }
    trimSpaces(str) {
        return str + ''.replace(" ", "");
    }
    setFiltersWithQS(qs) {
        const queryParams = this.parseQuery(qs);
        this.setQueryParamsFilterValues(this.parseQueryParamKeyValue(queryParams), queryParams);
        this.setQParams(qs);
    }
    getFilterLocalData(filterSlug, filterSource = this.DEFAULT_FILTER_DATA_SOURCE) {
        if (this.hasFilterData(filterSlug, filterSource))
            return this.filtersData[filterSource][filterSlug];
        return new filters_menu_data_1.FilterData;
    }
    clearFilterLocalData(filterSlug, filterSource = this.DEFAULT_FILTER_DATA_SOURCE) {
        if (this.hasFilterData(filterSlug, filterSource)) {
            delete this.filtersData[filterSource][filterSlug];
        }
    }
    getFilterLocalDataValues(filterSlug, filterSource, asArray = true) {
        const valuesIterable = this.getFilterLocalData(filterSlug, filterSource).data.values();
        // casting as 'any' until TS valid latest ES6 TS types are udpated; 
        return (asArray) ? Array.from(valuesIterable) : valuesIterable;
    }
    addFilterLocalData(filterSlug, filterSource = this.DEFAULT_FILTER_DATA_SOURCE, filterData, selected) {
        const parsedData = this.parseFilterData({ filterData, filterSlug, filterSource, selected });
        if (this.hasFilterData(filterSlug, filterSource)) {
            this.addValuesToMap(this.filtersData[filterSource][filterSlug].data, parsedData);
        }
        else {
            if (!this.filtersData[filterSource])
                this.filtersData[filterSource] = {};
            this.filtersData[filterSource][filterSlug] = {
                currentPage: 0,
                data: this.addValuesToMap(new Map(), parsedData),
                selectedFilters: new Set()
            };
        }
        return this.filtersData[filterSource][filterSlug];
    }
    parseFilterData({ filterData, filterSlug, filterSource, selected }) {
        if (filterData && filterData.length) {
            return filterData.map(d => {
                return Object.assign(d, {
                    selected: (typeof selected !== 'undefined')
                        ? typeof selected === 'function' ? selected(d) : !!selected
                        : !!this.hasSelectedFilterDataOpt(filterSlug, filterSource, this.buildFilterDataId(d)),
                    count: 0,
                    enabled: true
                });
            });
        }
        return [];
    }
    buildFilterDataId(filter) {
        // build a composed unique 
        return `${(filter.guid || filter.id)}_${filter.value}_${(filter.displayName || '').replace(/ /g, '').toLowerCase()}`;
    }
    addValuesToMap(map, valuesToAdd, mapKey) {
        for (let value of valuesToAdd) {
            map.set(mapKey || this.buildFilterDataId(value), value);
        }
        return map;
    }
    getFilterValueKey(filterValue) {
        // reverse keys order, use values as keys, and keys as values
        const valuesToKeys = Object.keys(this.FILTERS_KEYS).reduce((reverse, v) => (reverse[this.FILTERS_KEYS[v]] = v.toLowerCase(), reverse), {});
        // the keys values are use as the public endpoint name
        return valuesToKeys[filterValue] || '';
    }
    ;
    pullNewFilterData(filterSlug, filterSource = this.DEFAULT_FILTER_DATA_SOURCE, queryParams) {
        const queryParamsStr = this.buildFilterRequestParams({ filterSource, queryParams });
        const url = `${this.filtersUrl}/${filterSlug}?${queryParamsStr}`;
        return this._http.getCustomHeader(url, { key: 'adminrestrictfilters', value: this._dataLevel.restrict() })
            .toPromise()
            .then(res => {
            const totalFiltersCount = res.headers.get('x-total-count');
            const data = res.json().data || [];
            const totalCount = parseInt(totalFiltersCount || data.length);
            return {
                data,
                totalCount
            };
        });
    }
    buildFilterRequestParams({ filterSource, queryParams }) {
        const params = Object.assign({
            dataSource: filterSource,
            limit: 100
        }, queryParams || {});
        let queryParamsStr = `dataSource=${params.dataSource}&limit=${params.limit}`;
        if (params.report)
            queryParamsStr += `&report=true`;
        if (params.page)
            queryParamsStr += `&page=${params.page}`;
        if (params.value)
            queryParamsStr += `&value=${params.value}`;
        if (params.guid)
            queryParamsStr += `&guid=${params.guid.join(',')}`;
        if (params.id)
            queryParamsStr += `&id=${params.id.join(',')}`;
        if (params.client)
            queryParamsStr += `&client=${params.client.join(',')}`;
        if (params.type)
            queryParamsStr += `&type=${params.type.join(',')}`;
        if (params.searchWithInClause)
            queryParamsStr += `&searchWithInClause=${params.searchWithInClause}`;
        if (params.fuzzy) {
            queryParamsStr += `&fuzzy=true`;
        }
        let dealTypes = this.buildFilterSelectedValuesArr('deal_type', filterSource);
        let hasTMP = _.includes(dealTypes, 'tmp');
        let hasPMP = _.includes(dealTypes, 'pmp');
        if (hasTMP) {
            queryParamsStr += '&deal_type=1';
        }
        if (hasPMP) {
            queryParamsStr += '&deal_type=0';
        }
        return queryParamsStr;
    }
    bypassLoadFilterParamsData(filterSlug, filterSource) {
        return (
        // dont need to load publisher/client_id for client side
        // since the filters are selected by organization_id
        this._dataSource.isClientSide(filterSource) && filterSlug === this.FILTERS_KEYS.PUBLISHER);
    }
    setDataFilterParams(paramsValues, filterSlug, filterSource) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (this.bypassLoadFilterParamsData(filterSlug, filterSource))
                    return;
                const queryParams = {
                    limit: this.MAX_SELECTABLE_FILTERS,
                    [this.getSelectedValuesProp(filterSlug, filterSource)]: paramsValues,
                    // When searching by domain, search for all the values/names with IN clause
                    // only required until domains can be searched by IDs or GUIDs on all sources
                    searchWithInClause: (filterSlug === this.FILTERS_KEYS.DOMAIN || filterSlug === this.FILTERS_KEYS.SIZE),
                    report: true
                };
                const filterData = yield this.pullNewFilterData(this.getFilterValueKey(filterSlug), filterSource, queryParams);
                // Currently, we should not all values for organization
                // since those are not currently lazy loaded/not filtered on server side.
                const selectFilterValues = (filterSlug === this.FILTERS_KEYS.ORGANIZATION)
                    // select only values in paramsValues
                    ? filter => paramsValues.includes(String(filter.value))
                    // we can select all, since all the returned values, will be filtered by the paramsValues sent on request
                    : true;
                // Load the unique data values to the filter local store
                this.addFilterLocalData(filterSlug, filterSource, this.cleanDuplicatesFrom(filterData, 'value'), selectFilterValues);
                return filterData;
            }
            catch (err) {
                console.error(`Unable to get filter(${filterSlug}) values`, err);
                return err;
            }
        });
    }
    cleanDuplicatesFrom(arrayOfObjs, key) {
        return Array.from(arrayOfObjs.data.reduce((clean, obj) => (clean.set(obj[key], obj), clean), new Map()).values());
    }
    getFilterCurrentPage(filterSlug, filterSource = this.DEFAULT_FILTER_DATA_SOURCE) {
        if (this.hasFilterData(filterSlug, filterSource, false))
            return this.filtersData[filterSource][filterSlug].currentPage || 1;
        return 1;
    }
    setFilterCurrentPage(filterSlug, filterSource = this.DEFAULT_FILTER_DATA_SOURCE, page) {
        if (this.hasFilterData(filterSlug, filterSource, false)) {
            this.filtersData[filterSource][filterSlug].currentPage = page;
        }
    }
    hasFilterData(filterSlug, filterSource = this.DEFAULT_FILTER_DATA_SOURCE, checkDataOnly = true) {
        const foundObj = (this.filtersData[filterSource] && this.filtersData[filterSource][filterSlug]);
        if (checkDataOnly && foundObj) {
            for (let [key, value] of foundObj.data) {
                if (value.selected && !(foundObj.selectedFilters.has(key))) {
                    foundObj.selectedFilters.add(key);
                }
            }
            return !!(foundObj.data && foundObj.data.size);
        }
        else {
            return !!foundObj;
        }
    }
    hasFilterDataOpt(filterSlug, filterSource, searchBy) {
        const filterOpt = this.getFilterLocalData(filterSlug, filterSource).data.get(searchBy.key);
        return (filterOpt && filterOpt[searchBy.key] === searchBy.value);
    }
    hasSelectedFilterDataOpt(filterSlug, filterSource, searchKey) {
        const foundOpt = this.getFilterLocalData(filterSlug, filterSource).data.get(searchKey);
        return (foundOpt && foundOpt.selected);
    }
    resetAllFiltersData(filtersSource = this._dataSource.getCurrentSource().slug) {
        console.log('resetting filters data', filtersSource);
        this.callAllSourceFiltersWith(this.resetFilterData, filtersSource);
    }
    resetFilterData(filterSlug, filterSource = this.DEFAULT_FILTER_DATA_SOURCE) {
        if (this.hasFilterData(filterSlug, filterSource)) {
            this.filtersData[filterSource][filterSlug] = new filters_menu_data_1.FilterData;
        }
    }
    deselectAllFiltersOptions(filtersSource) {
        this.callAllSourceFiltersWith(this.deselectFilterOptions, filtersSource);
    }
    deselectFilterOptions(filterSlug, filterSource) {
        this.deselectMenuOptions(this.getFilterLocalDataValues(filterSlug, filterSource));
    }
    callAllSourceFiltersWith(fn, filtersSource) {
        for (let source in this.filtersData) {
            if (filtersSource && source !== filtersSource)
                continue;
            for (let filterSlug in this.filtersData[source]) {
                if (this.hasFilterData(filterSlug, filtersSource)) {
                    ;
                    fn.call(this, filterSlug, filtersSource);
                }
            }
        }
    }
    // [#652] Remove when transitioned to JSON Request
    buildFilterSelectedValuesStr(filterSlug, filterSource) {
        const filterDataValues = this.getFilterLocalDataValues(filterSlug, filterSource);
        const selectedValues = this.filterBySelectedValues(filterDataValues);
        if (filterSlug === this.FILTERS_KEYS.DOMAIN)
            return this.buildSelectedDomainsStr(selectedValues, filterDataValues, filterSlug);
        else
            return this.buildSelectedValuesQueryStr(selectedValues, filterDataValues, filterSlug);
    }
    buildFilterSelectedValuesArr(filterSlug, filterSource) {
        const filterDataValues = this.getFilterLocalDataValues(filterSlug, filterSource);
        const selectedValues = this.filterBySelectedValues(filterDataValues);
        if (filterSlug === this.FILTERS_KEYS.DOMAIN)
            return this.buildSelectedDomainsArr(selectedValues, filterDataValues, filterSlug);
        else
            return this.buildSelectedValuesQueryArr(selectedValues, filterDataValues, filterSlug);
    }
    filterBySelectedValues(values, selectedKey = 'selected') {
        return this._booleanKey.transform(values, true, selectedKey);
    }
    // [#652] Remove when transitioned to JSON Request
    buildSelectedDomainsStr(selectedDomains, domains, filterSlug) {
        let filtersStr = '';
        if (this.canUseAllSelectedFilterValues(selectedDomains)) {
            filtersStr += this.buildSelectedValuesQueryStr(selectedDomains, domains, filterSlug);
        }
        else if (this._dataLevel.restrict() || this.showAllDomains) {
            const clientAssociatedDomains = this._clients.getClientAssociatedDomains();
            for (let d in clientAssociatedDomains) {
                filtersStr += `&${filterSlug}=${clientAssociatedDomains[d]}`;
            }
        }
        return filtersStr;
    }
    buildSelectedDomainsArr(selectedDomains, domains, filterSlug) {
        let filtersArr = [];
        if (this.canUseAllSelectedFilterValues(selectedDomains)) {
            filtersArr = this.buildSelectedValuesQueryArr(selectedDomains, domains, filterSlug);
        }
        else if (this._dataLevel.restrict() || this.showAllDomains) {
            const clientAssociatedDomains = this._clients.getClientAssociatedDomains();
            for (let d in clientAssociatedDomains) {
                filtersArr.push(clientAssociatedDomains[d]);
            }
        }
        return filtersArr;
    }
    // [#652] Remove when transitioned to JSON Request
    buildSelectedValuesQueryStr(selectedValues, allValues, filterSlug) {
        let filtersStr = '';
        if (this.canUseAllSelectedFilterValues(selectedValues)) {
            const valueKey = this.getSelectedValuesProp(filterSlug);
            filtersStr += allValues.map(d => {
                if (d.selected) {
                    return `&${filterSlug}=${d[valueKey]}`;
                }
                return '';
            })
                .filter((value, idx, arr) => value && arr.indexOf(value) === idx) //ensure only unique values are joined
                .join('');
        }
        return filtersStr;
    }
    buildSelectedValuesQueryArr(selectedValues, allValues, filterSlug) {
        let filtersArr = [];
        if (this.canUseAllSelectedFilterValues(selectedValues)) {
            const valueKey = this.getSelectedValuesProp(filterSlug);
            filtersArr = allValues.map(d => {
                if (d.selected) {
                    return d[valueKey];
                }
                return '';
            })
                .filter((value, idx, arr) => value && arr.indexOf(value) === idx); //ensure only unique values are joined
        }
        return filtersArr;
    }
    getSelectedValuesProp(filterSlug, dataSourceSlug = this._dataSource.getCurrentSource().slug) {
        // for now only restricting the usage of GUID for filters  that provide it
        return (
        // orgs, deals and sizes are searched by value
        filterSlug !== this.FILTERS_KEYS.ORGANIZATION
            && filterSlug !== this.FILTERS_KEYS.DEAL
            && filterSlug !== this.FILTERS_KEYS.PUBLISHER
            && filterSlug !== this.FILTERS_KEYS.DEAL_TYPE)
            ? 'guid'
            : 'value';
    }
    canUseAllSelectedFilterValues(selectedValues = []) {
        // Make sure to only select values up to the max possible
        return selectedValues.length > 0 && selectedValues.length <= this.MAX_SELECTABLE_FILTERS;
    }
    adminFind(params = { filterSource: this.DEFAULT_FILTER_DATA_SOURCE, queryParams: {} }) {
        const queryParamsStr = this.buildFilterRequestParams(params);
        const url = `${this.filtersUrl}/adminFind?${queryParamsStr}`;
        return this._http.get(url).toPromise();
    }
    update(filterSlug, dataSource = this.DEFAULT_FILTER_DATA_SOURCE, data, filterId) {
        let url = `${this.filtersUrl}/${filterSlug}/update`;
        if (filterId)
            url += `/${filterId}`;
        if (dataSource)
            url += `?dataSource=${dataSource}`;
        return this._http.post(url, data).toPromise()
            .then(response => response.json());
    }
    omitOptionalKeys(object, keysToOmit = ['valuesSnap', 'createdAt', 'updatedAt']) {
        return _.omit(object, keysToOmit);
    }
    createObjectSnap(object) {
        return JSON.stringify(_.cloneDeep(object));
    }
    appendValuesSnap(object) {
        object.valuesSnap = this.createObjectSnap(object);
        return object;
    }
    getHelmDataSourcePermissions() {
        return this.HELM_DATA_TYPE_PERMISSIONS;
    }
};
exports.BidDataFilterService = BidDataFilterService;
exports.BidDataFilterService = BidDataFilterService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService,
        boolean_key_pipe_1.BooleanKeyPipe,
        bidder_service_1.BidderService,
        data_level_service_1.DataLevelService,
        clients_service_1.ClientsService,
        data_metric_service_1.DataMetricService,
        user_service_1.UserService,
        permission_service_1.PermissionService,
        data_source_service_1.DataSourceService,
        organizations_service_1.OrganizationsService])
], BidDataFilterService);
//# sourceMappingURL=bid-data-filter.service.js.map